import {
  CommonIncidentId,
  RugbyLeagueIncidentId,
} from '@collector/sportsapi-client-legacy'

import { HistoryFiltersConfig } from '../../../configuration'
import { historyFiltersAttributesConfig } from './historyFiltersAttributesConfig'
import { incidentIdsGroup } from './incidentsGroup'

export const historyFiltersConfig: HistoryFiltersConfig = {
  withConfirmation: true,
  historyFiltersAttributes: historyFiltersAttributesConfig,
  historyFiltersIncidents: [
    RugbyLeagueIncidentId.Try,
    RugbyLeagueIncidentId.PenaltyTry,
    RugbyLeagueIncidentId.ConversionGoal,
    RugbyLeagueIncidentId.ConversionMissed,
    RugbyLeagueIncidentId.ConversionAttempt,
    RugbyLeagueIncidentId.PenaltyKickGoal,
    RugbyLeagueIncidentId.PenaltyKickMissed,
    RugbyLeagueIncidentId.PenaltyAwarded,
    RugbyLeagueIncidentId.FreeKick,
    RugbyLeagueIncidentId.DropGoal,
    RugbyLeagueIncidentId.DropGoalMissed,
    RugbyLeagueIncidentId.YellowCard,
    RugbyLeagueIncidentId.RedCard,
    RugbyLeagueIncidentId.GreenCard,
    incidentIdsGroup,
    RugbyLeagueIncidentId.Scrum,
    RugbyLeagueIncidentId.Lineout,
    RugbyLeagueIncidentId.Kick,
    RugbyLeagueIncidentId.GoallineDropout,
    RugbyLeagueIncidentId.EntryInto20,
    RugbyLeagueIncidentId.Offload,
    RugbyLeagueIncidentId.Turnover,
    RugbyLeagueIncidentId.Foul,
    RugbyLeagueIncidentId.TackleMade,
    RugbyLeagueIncidentId.TackleBreak,
    RugbyLeagueIncidentId.Injury,
    RugbyLeagueIncidentId.InPossession,
    RugbyLeagueIncidentId.Timeout,
    CommonIncidentId.TechnicalProblems,
    RugbyLeagueIncidentId.RefereeReview,
    RugbyLeagueIncidentId.Kickoff,
    RugbyLeagueIncidentId.MedicalTimeout,
    RugbyLeagueIncidentId.BreakDuringGame,
    RugbyLeagueIncidentId.WaterBreak,
  ],
}
